// @flow

import * as React from 'react';

import { Ban, Check, LoaderCircle, TriangleAlert } from 'lucide-react';

import { IconContainer } from './IconContainer';
import type { AvailabilityIconName } from './IconContainer';

const svgComponent = {
  available: Check,
  available_secondary: Check,
  error: Ban,
  fail: Ban,
  lang_required: TriangleAlert,
  loading: LoaderCircle,
  ok: Check,
  unavailable: Ban,
  unknown: Ban,
  warning: TriangleAlert,
} as const;

type Props = {
  iconName: AvailabilityIconName,
  className?: string,
  variant?: 'compact',
};

export function Icon({
  iconName,
  className,
  variant,
}: Props): React.MixedElement {
  const Svg = svgComponent[iconName];

  return (
    <IconContainer className={className} iconName={iconName} variant={variant}>
      <Svg aria-hidden="true" />
    </IconContainer>
  );
}
